import {Button, Form, InputGroup, Modal} from 'react-bootstrap'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { Customer } from '../../model/Customer';
import { Meal } from '../../model/Meal';
import validator from 'validator'
import { CustomerRequestDTO } from '../../model/CustomerRequestDTO';
import './style.css'
import dayjs from 'dayjs';
import 'dayjs/locale/pl'
import { LocalDate } from 'local-date';
import {Switch} from "antd";

export const SaveEditCustomerModal : React.FC<{customer : Customer | null,
    show : boolean, setShow : Dispatch<SetStateAction<boolean>>, 
    index : number | null,
    lengthOfCustomersList : number,
    handleSaveToDatabase : (customerRequestDTO: CustomerRequestDTO) => Promise<() => void>,
    mealList : Meal[]
}> = (props) => {
  
    const {customer, show, setShow, index, lengthOfCustomersList, handleSaveToDatabase} = props
    const [firstName, setFirstName] = useState<string | undefined>()
    const [lastName, setLastName] = useState<string | undefined>()
    const [childName, setChildName] = useState<string | undefined>()
    const [email, setEmail] = useState<string | undefined>()
    const [description, setDescription] = useState<string | undefined>()
    const [position, setPosition] = useState<string | undefined>()
    const [activeStart, setActiveStart] = useState<dayjs.Dayjs | undefined>()
    const [activeEnd, setActiveEnd] = useState<dayjs.Dayjs | null>()
    const [customerid, setCustomerid] = useState<number | undefined>()
    const [active, setActive] = useState<boolean | undefined>()
    const [emailPresent, setEmailPresent] = useState<boolean>()
    const [errors, setErrors] = useState<Record<string, string[]>>({})

    useEffect(() => {
      setFirstName(customer !== null ? customer.firstName : '')
      setLastName(customer !== null ? customer.lastName : '')
      setChildName(customer !== null ? customer.childName : '')
      setEmail(customer !== null ? customer.email : '')
      setDescription(customer !== null ? customer.description : '')
      setPosition(customer !== null ? customer.position.toString() : (lengthOfCustomersList+1).toString())
      setActiveStart(customer !== null ? dayjs(customer.activeStart, 'YYYY-MM-DD').locale('pl'): dayjs().startOf('month'))
      setActiveEnd(customer !== null && customer.activeEnd !== null ? dayjs(customer.activeEnd, 'YYYY-MM-DD').locale('pl') : null)
      setCustomerid(customer !== null ? customer.customerid : undefined)
      setActive(customer !== null ? customer.active! : undefined)
      setEmailPresent(customer !== null ? customer.email !== "Brak" : true)
      setErrors({})
    // eslint-disable-next-line
    },[show])

    const handleExit = () => {
      setFirstName(customer !== null ? customer.firstName : '')
      setLastName(customer !== null ? customer.lastName : '')
      setChildName(customer !== null ? customer.childName : '')
      setEmail(customer !== null ? customer.email : '')
      setDescription(customer !== null ? customer.description : '')
      setPosition(customer !== null ? customer.position.toString() : (lengthOfCustomersList+1).toString())
      setActiveStart(customer !== null ? dayjs(customer.activeStart, 'YYYY-MM-DD').locale('pl'): dayjs().startOf('month'))
      setActiveEnd(customer !== null && customer.activeEnd !== null ? dayjs(customer.activeEnd, 'YYYY-MM-DD').locale('pl') : null)
      setCustomerid(customer !== null ? customer.customerid : undefined)
      setActive(customer !== null ? customer.active! : undefined)
      setEmailPresent(customer !== null ? customer.email !== "Brak" : true)
      setErrors({})
      setShow(false)
    }

    const handleSetPosition = (value : string)  => {
        let tempValue = value.replace(/\D/, '')
        if (!Number.isNaN(tempValue)) {
            setPosition(tempValue)
        }
    }

    const handleSave = () => {
      let newValidation = validateFields()
      if (Object.values(newValidation).some((error) => error)) {
        setErrors(newValidation)
        return;
      }
      setErrors({})
      let activeStartLocalDate = new LocalDate(activeStart!.format('YYYY-MM-DD'))
      let activeEndLocalDate = activeEnd !== null ? new LocalDate(activeEnd!.format('YYYY-MM-DD')) : null
      let tempCustomer = new Customer(firstName!, 
        lastName!, 
        childName!, 
        activeStartLocalDate, 
        activeEndLocalDate!, 
        email!, 
        description!,
        parseInt(position!),
        active === undefined ? true : active,
        customer?.parentGotAccount !== undefined ? customer?.parentGotAccount : false,
        [],
        customer?.paymentSummary !== null ? customer?.paymentSummary : undefined,
        customer?.customerMeals !== null ? customer?.customerMeals : [], 
        customerid)
      handleSaveToDatabase(new CustomerRequestDTO(tempCustomer))
      
      handleExit()
      setShow(false)
    };
    
    const validateFields = () => {
      let tempErrors : Record<string, string[]> = {'firstName' : [], 
        'lastName' : [], 
        'childName' : [],
        'email' : [], 
        'description' : [],
        'position' : [],
      }
      let errorsPresent = false

      if (firstName === null || firstName === undefined || firstName === '') {
        tempErrors.firstName.push('Pole Imienia rodzica nie może być puste.')
        errorsPresent = true
      } else if (firstName.length > 30) {
        tempErrors.firstName.push('Limit znaków dla imienia to 30.')
        errorsPresent = true
      }
      if (lastName === null || lastName === undefined || lastName === '') {
        tempErrors.lastName.push('Pole Nazwiska rodzica nie może być puste.')
        errorsPresent = true
      } else if (lastName.length > 60) {
        tempErrors.lastName.push('Limit znaków dla nazwiska to 60.')
        errorsPresent = true
      }
      if (childName === null || childName === undefined || childName === '') {
        tempErrors.childName.push('Pole Imienia i nazwiska dziecka nie może być puste.')
        errorsPresent = true
      } else if (childName.length > 100) {
        tempErrors.childName.push('Limit znaków dla imienia i nazwiska dziecka to 100.')
        errorsPresent = true
      }
      if (email === null || email === undefined || email === '') {
        tempErrors.email.push('Pole Email nie może być puste.')
        errorsPresent = true
      } else if (email.length > 150) {
        tempErrors.email.push('Limit znaków dla adresu email to 150.')
        errorsPresent = true
      } else if(!validator.isEmail(email) && emailPresent) {
        tempErrors.email.push('Niepoprawny format email.')
        errorsPresent = true
      }
      if (description !== undefined && description.length >= 100) {
        tempErrors.description.push('Limit znaków dla opisu to 100.')
        errorsPresent = true
      }
      if (position === null || position === undefined || position === '') {
          tempErrors.position.push('Pole pozycji nie może być puste.')
          errorsPresent = true
      }
      if (position !== undefined && (parseInt(position) > 100 || parseInt(position) < 1)) {
          tempErrors.position.push('Wartość musi się mieścić w przedziale 1-100')
          errorsPresent = true
      }
      if (!errorsPresent) {
        tempErrors = {}
      }

      return tempErrors
    }

    return (
        <Modal size='xl' show={show} backdrop={'static'} onHide={() => handleExit()}>
        <Modal.Header closeButton>
          <Modal.Title>{index !== null ? 'Edytuj klienta' : 'Utwórz klienta'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
              <Form.Group
                  className="mb-3"
                  controlId="position"
              >
                  <Form.Label>Pozycja</Form.Label>
                  <InputGroup className="mb-3">
                      <Form.Control
                          type="text"
                          value={position}
                          placeholder="Podaj preferowaną pozycję rodzica na liście"
                          onChange={(e) => handleSetPosition(e.target.value)}
                          isInvalid ={errors.position?.length > 0}
                          onFocus={() => errors.position = []}
                      />
                      {errors.position?.map((error : string, index : number) => (
                          <Form.Control.Feedback key={index} type="invalid">
                              {error}
                          </Form.Control.Feedback>
                      ))}
                  </InputGroup>

              </Form.Group>
            <Form.Group className="mb-3" controlId="firstName">
              <Form.Label>Imię rodzica</Form.Label>
              <Form.Control
                type="text"
                value={firstName}
                placeholder="Wpisz imię rodzica"
                onChange={(e) => setFirstName(e.target.value)}
                autoFocus
                isInvalid ={errors.firstName?.length > 0}
                onFocus={() => errors.firstName = []}
              />
              {errors.firstName?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							</Form.Control.Feedback>
              ))}
            </Form.Group>
            <Form.Group className="mb-3" controlId="lastName">
              <Form.Label>Nazwisko rodzica</Form.Label>
              <Form.Control
                type="text"
                value={lastName}
                placeholder="Wpisz nazwisko rodzica"
                onChange={(e) => setLastName(e.target.value)}
                autoFocus
                isInvalid ={errors.lastName?.length > 0}
                onFocus={() => errors.lastName = []}
              />
              {errors.lastName?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							</Form.Control.Feedback>
              ))}
            </Form.Group>
            <Form.Group className="mb-3" controlId="childName">
              <Form.Label>Imię i nazwisko dziecka</Form.Label>
              <Form.Control
                type="text"
                value={childName}
                placeholder="Wpisz imię i nazwisko dziecka"
                onChange={(e) => setChildName(e.target.value)}
                autoFocus
                isInvalid ={errors.childName?.length > 0}
                onFocus={() => errors.childName = []}
              />
              {errors.childName?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							</Form.Control.Feedback>
              ))}
            </Form.Group>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email <Switch
                  className='mx-3'
                  checkedChildren="Email dostępny"
                  unCheckedChildren="Brak emaila"
                  checked={emailPresent}
                  onClick={(e) => {setEmailPresent(prev => !prev); setEmail(e ? '' : 'Brak')}}
              /></Form.Label>
              <Form.Control
                type="text"
                value={email}
                disabled={!emailPresent}
                placeholder="Wpisz adres email"
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                isInvalid ={errors.email?.length > 0}
                onFocus={() => errors.email = []}
              />
              {errors.email?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							</Form.Control.Feedback>
              ))}
            </Form.Group>
            <Form.Group className="mb-3" controlId="description">
              <Form.Label>Opis</Form.Label>
              <Form.Control
                type="text"
                value={description}
                placeholder="Dodaj opis"
                onChange={(e) => setDescription(e.target.value)}
                autoFocus
                isInvalid ={errors.description?.length > 0}
                onFocus={() => errors.description = []}
              />
              {errors.description?.map((error : string, index : number) => (
                <Form.Control.Feedback key={index} type="invalid">
								{error}
							</Form.Control.Feedback>
              ))}
            </Form.Group>
          </Form>
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleExit()}>
            Zamknij
          </Button>
          <Button className='button-65' variant="primary" onClick={() => handleSave()}>
            Zapisz
          </Button>
        </Modal.Footer>
        
      </Modal>
    )
}